import React from 'react';

import PrivateHireQuickEstimatesForm from '@zego/flows/quickEstimates/privateHire/forms/PrivateHireQuickEstimatesForm';
import { primaryColor } from '@zego/theme';
import { TrackingScope } from '@zego/tracking';

import WidgetPageSection from '@zego/components/WidgetPageSection';

/**
 * @param {Object} props
 * @param {unknown} props.viewer
 * @param {string} [props.locationName]
 * @param {string} [props.source]
 */
const PrivateHireWidget = ({
  viewer,
  locationName = 'Private Hire Product Page',
  source,
  privateHireJourneySvcEnabledFlag,
}) => (
  <WidgetPageSection
    backgroundColor={primaryColor(11)}
    heading="Get your online estimate today"
  >
    <TrackingScope locationName={locationName}>
      <PrivateHireQuickEstimatesForm
        viewer={viewer}
        source={source}
        privateHireJourneySvcEnabledFlag={privateHireJourneySvcEnabledFlag}
      />
    </TrackingScope>
  </WidgetPageSection>
);

export default PrivateHireWidget;
